"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIDE_PRODUCT_FOLDERS_SHEPHERD = exports.USER_SETTINGS_UID = exports.BLOG_SETTINGS_NAMESPACE = void 0;
var BLOG_SETTINGS_NAMESPACE = 'blog';
exports.BLOG_SETTINGS_NAMESPACE = BLOG_SETTINGS_NAMESPACE;
var USER_SETTINGS_UID = 'user-settings-uid';
exports.USER_SETTINGS_UID = USER_SETTINGS_UID;
var HIDE_PRODUCT_FOLDERS_SHEPHERD = 'products:hide-product-folders-shepherd';
exports.HIDE_PRODUCT_FOLDERS_SHEPHERD = HIDE_PRODUCT_FOLDERS_SHEPHERD;